import {
  GAME_MOVES_KEY,
  derivePool,
  gameDocName,
  type PoolMove,
  type PoolState,
} from '@awwyeah/shared';
import type * as Y from 'yjs';
import { useYArray, useYDoc } from '../../sync';

/**
 * A pool match's move log (`game:<id>`, `Y.Array<PoolMove>`) plus the derived table — the
 * pool sibling of `useGameMoves`, and the same append-only contract: the table is never
 * stored, only ever replayed from the shots. Each entry is one whole turn including the
 * shooter's outcome snapshot, so `derivePool` needs no physics to rebuild the game (see
 * `packages/shared/src/modules/games/pool.ts`).
 */
export function usePoolMoves(
  gameId: string,
  playerIds: readonly [string, string],
): {
  doc: Y.Doc;
  movesArray: Y.Array<PoolMove>;
  moves: PoolMove[];
  state: PoolState;
} {
  const doc = useYDoc(gameDocName(gameId));
  const { array, items } = useYArray<PoolMove>(doc, GAME_MOVES_KEY);
  const state = derivePool(items, playerIds);
  return { doc, movesArray: array, moves: items, state };
}
